__turbopack_context__.v({
  "section": "ProjectSettingsSection-module__NdMpuG__section",
});
